/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unused-imports/no-unused-vars */
import React, { ReactNode, useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import { Tab } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import CloseIcon from "@mui/icons-material/Close";

import "./tabs.scss";
import TextField from "../text-field/text-field";
import { useTranslation } from "react-i18next";
import Typography from "../typography/typography";

interface TabItem {
  tab_order: number;
  title: string;
  content?: string | ReactNode;
  data?: any;
  remove_tab?: boolean;
}
export interface TabProps {
  tabs: TabItem[];
  activeValue?: number;
  setActiveValue?: React.Dispatch<React.SetStateAction<number | undefined>>;
  onEditTabTitle?: (tabId: number, newTitle: string) => void;
  handleTabChange?: () => void;
  handleRemoveTab?: (tabId: number) => void;
  isFormTabValid?: boolean ;
  isTabViewOnly?: boolean;
  activeTabs?: any[] ;
  setActiveTabs?: React.Dispatch<React.SetStateAction<number | undefined>>;
  containerProps?: any;
}

export const TabBar = (props: TabProps) => {
  const { t } = useTranslation();
  const {
    tabs,
    onEditTabTitle,
    activeValue,
    setActiveValue,
    handleTabChange,
    handleRemoveTab,
    // isFormTabValid ,  
    isTabViewOnly,
    activeTabs, 
    containerProps
  } = props; 
  
  const [value, setValue] = useState<number>(activeValue || 0);
  const [editableTabId, setEditableTabId] = useState<number | null>(null);
  useEffect(()=>{
    activeValue && setValue(activeValue);
	} , [activeValue])

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setActiveValue && setActiveValue(newValue);
    handleTabChange && handleTabChange();
  };

  const handleTabDoubleClick = (tabId: number) => {
    setEditableTabId(tabId);
  };

  const handleEditTabTitle = (
    event: React.ChangeEvent<HTMLInputElement>,
    tabId: number,
  ) => {
    onEditTabTitle && onEditTabTitle(tabId, event.target.value);
  };

  // useEffect(() => {
  //   if (setActiveValue && Boolean(tabs?.length)) setActiveValue(value);
  //   // eslint-disable-next-line
  // }, [tabs]);

  return (
    <Box mb={2} {...containerProps}>
      <TabContext value={activeValue ?? value }>
        <Box>
          <TabList className="account-payble-tabs-wrap" onChange={handleChange} variant="scrollable" scrollButtons="auto" aria-label="scrollable tabs" sx={{ overflowX: 'auto', maxWidth: '100%' }}>
            {tabs.map((tab: TabItem, index: any) => (
              <Tab
                className="account-payble-tab-items"
                key={tab.tab_order}
              
                label={
                  <Box display='flex' alignItems='center'>
                    {
                        onEditTabTitle && editableTabId === tab.tab_order ? (
                          <TextField
                            value={tab.title}
                            autoFocus
                            onBlur={() => setEditableTabId(null)}
                            onChange={(e: any) =>
                              handleEditTabTitle(e, tab.tab_order)
                            }
                          />
                        ) : handleRemoveTab ? (
                          <div className="Tabs--Title">
                            <Typography color='theme.secondary.1000' type='s3'>{t(tab.title)}</Typography>
                            {!tab.remove_tab && (
                              <IconButton size="small" onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleRemoveTab(tab.tab_order);
                              }}>
                                <CloseIcon style={{ fontSize: "15px", cursor: "pointer" }}/>
                              </IconButton>
                            )}
                          </div>
                        ) : (
                          <Typography color='theme.secondary.1000' type='s3'>{t(tab.title)}</Typography>
                        )
                    }
                  </Box>
                }
                wrapped
                onDoubleClick={() => handleTabDoubleClick(tab.tab_order)}
              />
            ))}
          </TabList>
        </Box>
        {tabs.map(
          (tab: TabItem, index: number) =>
            tab.content && (
              <TabPanel value={index.toString()} key={tab.tab_order}>
                {value === index && tab.content}
              </TabPanel>
            ),
        )}
      </TabContext>
    </Box>
  );
}

export default TabBar;